import {
    useCallback,
    useMemo, useState,
} from 'react'
import Button from 'app/shared-components/Button'
import FormWithControls from 'app/shared-components/FormWithControls'
import useEnumValues from 'app/hooks/useEnumValues'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import ConfirmationDialog from 'app/shared-components/ConfirmationDialog'
import loggerPairingRequests from 'app/requests/LoggerPairing.requests'
import useLabel from 'app/hooks/useLabel'

import useDeleteLoggerPairing from '../hooks/useDeleteLoggerPairing'
import {
    LoggerFormData,
} from '../LoggerForm/LoggerForm.types'
import getFields from './LoggerUpdateForm.fields'
import useStyles from './LoggerUpdateForm.styles'

const LoggerUpdateForm = ({
    serialNumber,
    data,
    refresh,
}: Readonly<{
    data: LoggerFormData,
    serialNumber: string,
    refresh: () => void
}>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()
    const getEnumValues = useEnumValues()
    const [
        confirmation,
        setConfirmation,
    ] = useState(false)
    const value = useMemo(() => {
        return {
            ...data,
            loggerNumber: data?.logger?.loggerNumber,
            loggerType: data?.logger?.loggerType,
        }
    }, [data])

    const fields = useFieldsWithClassName(getFields({
        getEnumValues,
        removedOnDisabled: Boolean(data.removedOn),
        loggerNumber: data?.logger?.loggerNumber,
    }), classes)

    const {
        mutate: deleteLoggerPairing,
    } = useDeleteLoggerPairing(refresh)

    const onConfirm = useCallback((positive) => {
        if (positive) {
            deleteLoggerPairing({
                serialNumber, id: data?.id,
            })
        }
        setConfirmation(false)
    }, [
        deleteLoggerPairing,
        serialNumber,
        data?.id,
    ])

    const customButtons = useMemo(() => {
        return [<Button
            label={l('DELETE')}
            name="delete"
            onClick={() => {
                return setConfirmation(true)
            }}
        />]
    }, [l])

    return (
        <>
            <FormWithControls
                name="LoggerInformationDto"
                value={value}
                fields={fields}
                classNames={{
                    gridWrapper: classes.gridWrapper,
                }}
                requestParams={loggerPairingRequests.update({
                    serialNumber,
                })}
                customButtons={customButtons}
                exists
                createEnabled={!data.removedOn}
                onSuccess={refresh}
                className={classes.form}
            />
            <ConfirmationDialog
                dialogTitle={l('DELETE_CONFIRMATION')}
                open={confirmation}
                dialogContent={l('YOU_ARE_ABOUT_TO_DELETE_THIS_ITEM_PERMANENTLY_ARE_YOU_SURE')}
                handleClose={onConfirm}
                classNames={{
                    title: classes.title,
                    content: classes.title,
                }}
            />
        </>

    )
}

export default LoggerUpdateForm
